import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Actions, ofType } from '@ngrx/effects';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';

import { Store } from '@ngrx/store';
import { CoreState } from './store/core/states';
import { appActions, routerActions } from './store/core/actions';
import { SeoService } from '@modules/shared/services/seo.service';
import { filter } from 'rxjs/operators';
import { userPermissionActions } from '@modules/user/store/actions';

import firebase from "firebase/app";
import "firebase/messaging";
import { AuthService } from '@framework/services';
import { TranslateService } from './store/http/translate.service';
import { companyLanguagesActions } from '@modules/company-admin/store/actions';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {

  title = 'GoodSeeker';
  token: any;
  isOpen:boolean = false;
  languages: any[] = [];
  public isBrowser:boolean;
  getLanguageSubscription: any;
  constructor(
    private store$: Store<CoreState>,
    private router: Router,
    @Inject(PLATFORM_ID) platformId: Object,
    private activatedRoute: ActivatedRoute,
    private seoService: SeoService,
    private translate: TranslateService,
    private actions$: Actions,

  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const linkQueryParam = sessionStorage.getItem('linkQueryParam');
        if (linkQueryParam) {
          const nextUrl = atob(decodeURI(linkQueryParam));
          if (event.url == nextUrl) {
            sessionStorage.removeItem('linkQueryParam');
          }
        }

      });

      this.activatedRoute.queryParams.subscribe(params => {
        const lang = params['lang'];
    
        // if lang exists AND is not 'fr'
        if (lang && lang !== 'en') {
    
        }
    
        // initialize translations
     
      });

      // this.AngularFireMessaging.messages.subscribe(
      //   (_messaging: AngularFireMessaging) => {
      //     _messaging.onMessage = _messaging.onMessage.bind(_messaging);
      //     _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
      //   }
      // )

  //     this.oneSignal.init({
  //       appId: "a6c595b9-d88b-4b16-b3f2-9c428d8f886b",
  //       safari_web_id: "web.onesignal.auto.01ea4289-b460-45e4-8d90-838752554827",
  //       notifyButton: {
  //         enable: true,
  //       },
  //       subdomainName: "goodseeker-123",
  //       allowLocalhostAsSecureOrigin: true,
  //          serviceWorkerParam: {
  //    scope: 'assets/js/OneSignalSDKWorker.js'
  //  },
  //  serviceWorkerPath: 'assets/js/OneSignalSDKWorker.js'
  //     }).then((response)=>{
  //     //console.log("Subscribed",response)
  //     }).catch((error)=>{
  //       //console.log(error)
  //     });
  }

  ngOnInit(): void {
    const linkQueryParam = sessionStorage.getItem('linkQueryParam');
    if (linkQueryParam) {
      sessionStorage.removeItem('linkQueryParam');
    }
    // firebase.initializeApp(environment.firebase);
    // const messaging = firebase.messaging();


// Notification.requestPermission().then((permission)=>{

//   if(permission == 'granted'){
//     messaging.getToken({ vapidKey: environment.firebase.vapidKey }).then((currentToken) => {
//       if (currentToken) {
//         // Send the token to your server and update the UI if necessary
//         // ...
//       } else {
//         // Show permission request UI
//         //console.log('No registration token available. Request permission to generate one.');
//         // ...
//       }
//     }).catch((err) => {
//       //console.log('An error occurred while retrieving token. ', err);
//       // ...
//     });
//   }
// })

      // this.store$.dispatch(
      //   new companyLanguagesActions.LoadSelected(1517
      //   )
      // );


    this.store$.dispatch(new appActions.AppInitialized());
    if(this.isBrowser){
      this.store$.dispatch(new userPermissionActions.LoadPermissions());
      this.loadCompanyFromUrlSSR()
      // this.store$.dispatch(
      //   new companyLanguagesActions.LoadSelected(893)
      // );

    }

    // this.seoService.clearMetaTags();
    // this.meta.updateTag({ property: "og:title", content: 'Mindfire' });

    this.subscribe();
  }

  loadCompanyFromUrlSSR() {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
  
    let company: string | null = null;
  
    // something.staging.goodseeker.com
    if (
      parts.length === 4 &&
      parts[1] === 'staging' &&
      parts[2] === 'goodseeker'
    ) {
      company = parts[0];
    }
  
    // something.goodseeker.com
    else if (
      parts.length === 3 &&
      parts[1] === 'goodseeker'
    ) {
      company = parts[0];
    }
  
    // ❌ Excluded hosts
    if (!company || company === 'staging' || company === 'my') {
      this.languages.push({"name":"English","code":"en","flag":"https://flagcdn.com/w40/gb.png"})
      return;
    }
  
    // ✅ Dispatch only once
    this.store$.dispatch(
      new companyLanguagesActions.LoadSelected(company)
    );
  }
  // Private functions
  private subscribe() {
    // const languages = ['ar','fr','ka']
    // this.injectGoogleTranslate(languages)

    // this.activatedRoute.queryParams.subscribe(params => {
    //   const lang = params['lang'];
  
    //   // if lang exists AND is not 'fr'
    //   if (lang && lang !== 'en') {
    //     this.isOpen = true;
    //   }
  
    //   // initialize translations
   
    // });
 
    this.getLanguageSubscription = this.actions$
  .pipe(
    ofType<companyLanguagesActions.LoadSelectedSuccess>(
      companyLanguagesActions.ActionTypes.LOAD_SELECTED_SUCCESS
    )
  )
  .subscribe((action: any) => {
    const apiResponse = action.response || [];

    this.languages = apiResponse.map((l: any) => ({
      name: l.selected_lang_name,
      code: l.selected_lang_code,
      flag: l.flag
    }));
    this.languages.push({"name":"English","code":"en","flag":"https://flagcdn.com/w40/gb.png"})
    this.translate.init(this.languages);
    localStorage.setItem('languages', JSON.stringify(this.languages));
  });
 
  
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        // Alsway scroll to top when change route 
        this.scrollToTop();
        const lastChild = this.getLastActivatedRouteChild(this.activatedRoute);
        this.store$.dispatch(new routerActions.Navigated(lastChild.snapshot.data.pageName));
      }
    });
  }

  private scrollToTop() {
    if (this.isBrowser) {
      window.scrollTo(0, 0);
    }
  }



  injectGoogleTranslate(languages: string[]) {
    const langFromUrl = new URLSearchParams(window.location.search).get('lang');
  
    // Prevent duplicate script injection
    if (document.getElementById('google-translate-script')) {
      return;
    }
  
    // Select language from URL
    if (langFromUrl) {
      document.cookie = `googtrans=/auto/${langFromUrl};path=/`;
      document.cookie = `googtrans=/auto/${langFromUrl};path=/;domain=${location.hostname}`;
    } else {
      // Reset to English
      document.cookie =
        'googtrans=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;';
      document.cookie =
        `googtrans=;path=/;domain=${location.hostname};expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
    }
  
    // Google translate init
    (window as any).googleTranslateElementInit = () => {
      new (window as any).google.translate.TranslateElement(
        {
          pageLanguage: 'en',
          includedLanguages: ['en', ...languages].join(','),
          autoDisplay: false
        },
        'google_translate_element'
      );
    };
  
    // Load script
    const script = document.createElement('script');
    script.id = 'google-translate-script';
    script.src =
      '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    document.head.appendChild(script);
  }
  // receiveMessage() {
  //   this.AngularFireMessaging.messages.subscribe(
  //   (payload) => {
  //     //console.log("new message received. ", payload);
  //     // this.currentMessage.next(payload);
  //   })
  // }
  private getLastActivatedRouteChild(activatedRoute: ActivatedRoute): ActivatedRoute {
    if (activatedRoute.children.length > 0) {
      return this.getLastActivatedRouteChild(activatedRoute.firstChild);
    }
    return activatedRoute;
  }
}
